import React, { useState, useEffect } from "react";
import Head from "next/head";
import { useRouter } from "next/compat/router";

function SeoDefinition(props) {
  const router = useRouter();

  let metaDescription = "";
  if (props?.seoData?.metaDescription) {
    metaDescription = props.seoData.metaDescription;
  } else {
    // Fallback
    if (props?.seoData?.plp_header) {
      metaDescription = `Shop ${props.seoData.plp_header} and more luxury fashion, beauty & lifestyle pieces at Olivela. 20% of proceeds from every purchase supports causes you care about.`;
    } else if (props?.otherData?.plp_header === "sale") {
      metaDescription =
        "Shop discounted luxury fashion, beauty & lifestyle pieces at Olivela. 20% of proceeds from every purchase supports causes you care about.";
    } else if (props?.otherData?.type === "New Arrivals") {
      metaDescription =
        "Shop new in luxury fashion, beauty & lifestyle pieces at Olivela. 20% of proceeds from every purchase supports causes you care about.";
    } else {
      metaDescription =
        "Shop luxury fashion, beauty & lifestyle pieces at Olivela where 20% of proceeds from every purchase supports causes you care about.";
    }
  }

  let pageTitle = "";
  if (props?.seoData?.pageTitle) {
    pageTitle = props.seoData.pageTitle;
  } else {
    // Fallback
    let placeholder = "";
    if (props.otherData) {
      if (props.otherData.type === "sale") {
        placeholder = "Sale";
      } else if (props.otherData.type === "newest") {
        placeholder = "New arrivals";
      } else {
        placeholder =
          props.otherData.brand_name ||
          props.otherData.nav_subcat ||
          props.otherData.nav_cat ||
          props.otherData.nav_type;
      }
    }
    if (placeholder)
      pageTitle = `${placeholder} | Women’s designer fashion | Olivela`;
    else pageTitle = "Women’s designer fashion | Olivela";
  }

  let ogUrl = props.url || process.env.NETLIFY_URL;
  if(props?.otherData?.type === "sale") {
    ogUrl = router.asPath ? `${process.env.NETLIFY_URL}${router.asPath}` : `${process.env.NETLIFY_URL}/sale`;
  }


  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta name="title" content={pageTitle} />
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={pageTitle}></meta>
        <meta property="og:description" content={metaDescription}></meta>
        <meta property="og:url" content={ogUrl}></meta>
        <meta property="og:image" content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}></meta>
        <meta property="og:image:secure_url" content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}></meta>
        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="628"></meta>
      </Head>
    </>
  );
}

export default SeoDefinition;
